"use strict";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

(function () {
  "use strict";

  angular.module("vehicles").controller("VehiclesCtrl.bulk", Ctrl);

  function Ctrl(vm, $timeout, UsersService, VehiclesService, InsurerContractsService, GroupsService) {
    var _this = this;

    var service = VehiclesService;

    vm.nbCheckbox = 0;

    vm.countCheckBox = function () {
      console.log("countCheckBox");
      var count = 0;
      for (var index = 0; index < vm.rawData.length; index++) {
        if (vm.rawData[index].checkbox == true) {
          count++;
        }
      }

      vm.nbCheckbox = count;
    };

    vm.outDateToApply = new Date(); // Default case

    vm.onOutDateToApply = function (value) {
      vm.outDateToApply = value;
    };

    vm.actionChange = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var groupsCase4, groupsCase5;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log("action change", vm.action);

              _context.t0 = vm.action;
              _context.next = _context.t0 === "1" ? 4 : _context.t0 === "4" ? 9 : _context.t0 === "5" ? 14 : _context.t0 === "21" ? 19 : _context.t0 === "6" ? 21 : _context.t0 === "24" ? 27 : _context.t0 === "25" ? 27 : 32;
              break;

            case 4:
              _context.next = 6;
              return InsurerContractsService.getSelectArray();

            case 6:
              vm.allContracts = _context.sent;

              vm.allContracts.unshift({ value: "", name: "Aucun" });
              return _context.abrupt("break", 32);

            case 9:
              _context.next = 11;
              return GroupsService.getSelectArray();

            case 11:
              groupsCase4 = _context.sent;

              vm.groupsArray = groupsCase4;
              return _context.abrupt("break", 32);

            case 14:
              _context.next = 16;
              return GroupsService.getSelectArray(true);

            case 16:
              groupsCase5 = _context.sent;

              vm.groupsArray = groupsCase5;
              return _context.abrupt("break", 32);

            case 19:
              vm.allFields = [{ value: "type", name: "Type" }, { value: "insurerContract", name: "Contrat d'assurance" }, { value: "mileage", name: "Dernier relevé kms" }, { value: "mileageDate", name: "Date du dernier relevé kms" }, { value: "zipCode", name: "Code postal du lieu de parking" }, { value: "city", name: "Ville du lieu de parking" }, { value: "carRentalName", name: "Nom du loueur" }, { value: "carReturnDate", name: "Date de restitution au loueur" }, {
                value: "carRentalCost",
                name: "Coût mensuel de la location (HT)"
              }, { value: "defaultManagerId", name: "Gestionnaire du véhicule" }, { value: "inDate", name: "Date d'entrée" }, { value: "outDate", name: "Date de sortie" }, { value: "restitutionCost", name: "Coût de restitution" }, { value: "brand", name: "Marque" }, { value: "model", name: "Modèle" }, { value: "color", name: "Couleur" }, { value: "critAirType", name: "Certificat qualité de l'air" }, { value: "note", name: "Commentaires" }, { value: "engineType", name: "Source d'énergie" }, { value: "parkingAidRear", name: "Radar de recul" }, { value: "parkingAidFront", name: "Radar avant" }, { value: "cameraRear", name: "Caméra de recul" }, { value: "cameraFront", name: "Caméra avant" }, {
                value: "laneDepartureWarning",
                name: "Alerte Franchissement de Ligne (LDW)"
              }, { value: "airConditioning", name: "Climatisation" }, { value: "gps", name: "GPS" }, { value: "cruiseControl", name: "Régul. de vitesse" }, { value: "limitControl", name: "Limiteur de vitesse" }, {
                value: "adaptiveCruiseControl",
                name: "Régul. de vitesse adaptatif (ACC)"
              }, { value: "allSeasonTire", name: "Pneus 4 saisons" }, {
                value: "allSeasonTireLastDate",
                name: "Date montage pneus 4 saisons"
              }, { value: "winterTire", name: "Pneus hiver" }, { value: "winterTireLastDate", name: "Date montage pneus hiver" }];
              return _context.abrupt("break", 32);

            case 21:
              _context.next = 23;
              return UsersService.remoteSelectArray(["Manageur", "Gestionnaire Parc"]);

            case 23:
              vm.allManagers = _context.sent;

              vm.allManagers = vm.allManagers.filter(function (element) {
                return element.value !== "$";
              });
              vm.allManagers.unshift({ value: "", name: "Aucun" });
              return _context.abrupt("break", 32);

            case 27:
              _context.next = 29;
              return UsersService.remoteSelectArray(["Conducteur"]);

            case 29:
              vm.allDrivers = _context.sent;

              vm.allDrivers = vm.allDrivers.filter(function (element) {
                return element.value !== "$";
              });
              return _context.abrupt("break", 32);

            case 32:

              $timeout(function () {}, 10);

            case 33:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    vm.updateAll = function () {
      switch (vm.action) {
        case "1":
          vm.update({
            dataList: [{
              filters: { _id: { $in: vm.getSelectedId() } },
              vals: {
                insurerContract: vm.contractIdToApply
              }
            }]
          });
          break;

        case "4":
          vm.update({
            dataList: [{
              filters: { _id: { $in: vm.getSelectedId() } },
              vals: {
                $addToSet: {
                  groupsId: vm.groupIdToApply
                }
              }
            }]
          });
          break;

        case "5":
          vm.update({
            dataList: [{
              filters: { _id: { $in: vm.getSelectedId() } },
              vals: {
                $pull: {
                  groupsId: vm.groupIdToApply
                }
              }
            }]
          });
          break;

        case "6":
          vm.update({
            dataList: [{
              filters: { _id: { $in: vm.getSelectedId() } },
              vals: {
                defaultManagerId: vm.managerToApply === "" ? null : vm.managerToApply
              }
            }]
          });
          break;

        case "10":
          vm.deleteIds(vm.getSelectedId());
          break;

        case "20":
          vm.update({
            dataList: [{
              filters: { _id: { $in: vm.getSelectedId() } },
              vals: {
                outDate: vm.outDateToApply
              }
            }]
          });
          break;

        case "21":
          var vals = {};
          vals[vm.fieldToUnset] = null;

          vm.update({
            dataList: [{
              filters: { _id: { $in: vm.getSelectedId() } },
              vals: vals
            }]
          });
          break;

        case "23":
          vm.update({
            dataList: [{
              filters: { _id: { $in: vm.getSelectedId() } },
              vals: {
                toCheck: false
              }
            }]
          });
          break;

        case "24":
          vm.update({
            dataList: [{
              filters: { _id: { $in: vm.getSelectedId() } },
              vals: {
                $addToSet: {
                  _driverIds: vm.driverIdToApply.replace("$", "")
                }
              }
            }]
          });
          break;

        case "25":
          vm.update({
            dataList: [{
              filters: { _id: { $in: vm.getSelectedId() } },
              vals: {
                $pull: {
                  _driverIds: vm.driverIdToApply.replace("$", "")
                }
              }
            }]
          });
          break;
      }
    };

    vm.getSelectedId = function () {
      var idList = [];

      for (var index = 0; index < vm.rowsSelected.length; index++) {
        idList.push(vm.rowsSelected[index].data._id);
      }
      return idList;
    };

    vm.deleteIds = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(ids) {
        var confirm, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _id;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return swal({
                  title: "Voulez-vous vraiment supprimer " + ids.length + " v\xE9hicule(s) ?",
                  icon: "warning",
                  dangerMode: true,
                  buttons: {
                    cancel: "Non",
                    confirm: "Oui"
                  }
                });

              case 2:
                confirm = _context2.sent;

                if (!confirm) {
                  _context2.next = 39;
                  break;
                }

                Notiflix.Loading.standard("Cliquez pour interrompre le chargement...");
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 8;
                _iterator = ids[Symbol.iterator]();

              case 10:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context2.next = 23;
                  break;
                }

                _id = _step.value;
                _context2.prev = 12;
                _context2.next = 15;
                return service.deleteById(_id);

              case 15:
                _context2.next = 20;
                break;

              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2["catch"](12);

                console.error(_context2.t0);

              case 20:
                _iteratorNormalCompletion = true;
                _context2.next = 10;
                break;

              case 23:
                _context2.next = 29;
                break;

              case 25:
                _context2.prev = 25;
                _context2.t1 = _context2["catch"](8);
                _didIteratorError = true;
                _iteratorError = _context2.t1;

              case 29:
                _context2.prev = 29;
                _context2.prev = 30;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 32:
                _context2.prev = 32;

                if (!_didIteratorError) {
                  _context2.next = 35;
                  break;
                }

                throw _iteratorError;

              case 35:
                return _context2.finish(32);

              case 36:
                return _context2.finish(29);

              case 37:
                Notiflix.Loading.remove();
                vm.refresh();

              case 39:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this, [[8, 25, 29, 37], [12, 17], [30,, 32, 36]]);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }();

    vm.update = function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(data) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                Notiflix.Loading.standard("Cliquez pour interrompre le chargement...");
                _context3.prev = 1;
                _context3.next = 4;
                return VehiclesService.customPatch("update", data);

              case 4:
                _context3.next = 10;
                break;

              case 6:
                _context3.prev = 6;
                _context3.t0 = _context3["catch"](1);

                // Show error
                Notiflix.Notify.failure("Erreur lors de la mise à jour");
                console.error(_context3.t0);

              case 10:
                Notiflix.Loading.remove();
                vm.refresh();

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this, [[1, 6]]);
      }));

      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }();
  }
})();